import { SiteId } from '../../../../contexts/MenuContext/mapping.mjs';
import '../../assets/product-list-assets/cameras/door-access/retrofit-reader.jpg.mjs';
import { readersAndIntercom } from '../product-list-groups/readersAndIntercom.mjs';
import '../properties/index.mjs';
import { cameraReader } from '../properties/cameraReader.mjs';
import { twoWayIntercom } from '../properties/twoWayIntercom.mjs';
import { directory } from '../properties/directory.mjs';
import { touchPassSupport } from '../properties/touchPassSupport.mjs';
import { pinAccess } from '../properties/pinAccess.mjs';
import { nfcCard } from '../properties/nfcCard.mjs';
import { mobileAppAccess } from '../properties/mobileAppAccess.mjs';
import { hand } from '../properties/hand.mjs';
import { outdoorReady } from '../properties/outdoorReady.mjs';
import { readerPowerMethod } from '../properties/readerPowerMethod.mjs';
import image__default from "../../../../assets/retrofit-reader.jpg";
"use strict";
const retrofitReader = {
  id: "retrofitReader",
  productTitle: "Retrofit Reader",
  image: {
    src: image__default,
    width: 200,
    height: 160
  },
  v3Image: {
    src: image__default,
    width: 255,
    height: 182
  },
  productListGroup: readersAndIntercom,
  description: "retrofitReader.description",
  techspecsPath: [SiteId.TechSpecs, `/unifi/door-access/ua-retrofit-reader`],
  storePathParts: {
    category: "door-access-readers",
    productSlug: "ua-retrofit-reader",
    collectionSlug: "access-reader"
  },
  isNew: true,
  isComingSoon: true,
  comingSoonButtonText: "accessRetrofit.comingSoon",
  propertyValues: [{
    propertyId: "dimensions",
    value: {
      type: "string",
      value: '117 x 45 x 13.3 mm\n(4.6 x 1.8 x 0.5")'
    }
  }, {
    propertyId: cameraReader.id,
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: twoWayIntercom.id,
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: directory.id,
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: touchPassSupport.id,
    value: {
      type: "string",
      value: "Apple Wallet\nGoogle Wallet"
    }
  }, {
    propertyId: pinAccess.id,
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: nfcCard.id,
    value: {
      type: "boolean",
      value: true
    }
  }, {
    propertyId: mobileAppAccess.id,
    value: {
      type: "boolean",
      value: true
    }
  }, {
    propertyId: hand.id,
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: outdoorReady.id,
    value: {
      type: "translation",
      value: "retrofitReader.outdoorReady"
    }
  }, {
    propertyId: readerPowerMethod.id,
    value: {
      type: "translation",
      value: "retrofitReader.powerMethod"
    }
  }]
};
export { retrofitReader };
//# sourceMappingURL=retrofitReader.mjs.map
